export default "__VITE_ASSET__DTd50IWM__"